export default __webpack_public_path__ + "static/media/my-training-icon.960e3a5a.svg";